import { ReactElement } from "react";
import styles from "./layout.module.css";
import TextLogo from "@/components/TextLogo/TextLogo";
import Flex from "@/components/Flex/Flex";

type LoginLayoutProps = {
  children: ReactElement;
};

const LoginLayout = ({
  children,
}: LoginLayoutProps) => {
  return (
    <div className={styles.loginContainer}>
      <div className={styles.formContainer}>
        <div className={styles.logo}>
          <TextLogo />
        </div>
        {children}
        <Flex gap={2} justify="center" style={{marginTop:"auto"}}>
          <span className="small-text">© Boxem</span>
          <span className="small-text">
            <a href="https://www.boxem.com/privacypolicy" target="_blank">Privacy</a>
          </span>
          <span className="small-text">
            <a href="https://www.boxem.com/termsandconditions" target="_blank">Terms</a>
          </span>
        </Flex>
      </div>
      <div className={styles.testimonialsContainer}>
        <img
          style={{
            width: "100%",
            flex: 1,
            objectFit: "none",
            objectPosition: "center bottom",
          }}
          src="/images/login-illustration.svg"
        />
      </div>
    </div>
  );
};


export default LoginLayout;